import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const RenewalActionsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid ${colors.neutral[300]};
  width: 100%;
  margin-top: 2rem;
`;
